//CONSTANTS
import {
  GET_RECOMMENDATIONS_SUCCESS,
  GET_RECOMMENDATIONS_BY_CONTROL_ID_SUCCESS ,
} from "./constants"

const initialState = {
  listRecommendations: [],
  recommendationsByControlId: [],
}

function RecommendationsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        listRecommendations: payload,
      }
    case GET_RECOMMENDATIONS_BY_CONTROL_ID_SUCCESS:
      return {
        ...state,
        recommendationsByControlId: payload,
      }
    default:
      return state
  }
}

export default RecommendationsReducer
